import { render, staticRenderFns } from "./GlossKpis.vue?vue&type=template&id=4a279638"
import script from "./GlossKpis.vue?vue&type=script&lang=js"
export * from "./GlossKpis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports